import { render, staticRenderFns } from "./monitor.vue?vue&type=template&id=4b58e545"
import script from "./monitor.vue?vue&type=script&lang=ts"
export * from "./monitor.vue?vue&type=script&lang=ts"
import style0 from "./monitor.vue?vue&type=style&index=0&id=4b58e545&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b58e545')) {
      api.createRecord('4b58e545', component.options)
    } else {
      api.reload('4b58e545', component.options)
    }
    module.hot.accept("./monitor.vue?vue&type=template&id=4b58e545", function () {
      api.rerender('4b58e545', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/monitor/monitor.vue"
export default component.exports